export default __webpack_public_path__ + "static/media/session4.5ad25476.svg";